
import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import { SubscriptionStats } from "@/components/subscriptions/SubscriptionStats";

const Dashboard = () => {
  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full bg-gray-100">
        <AppSidebar />
        <div className="flex-1">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="mb-8">
              <h1 className="text-4xl font-bold" style={{ color: "#008169" }}>
                Welcome to Dashboard
              </h1>
              <p className="text-xl text-gray-600 mt-2">
                Manage your subscriptions and profile
              </p>
            </div>
            
            <SubscriptionStats />
            
            <div className="bg-white shadow-sm rounded-lg p-6">
              <p className="text-lg text-gray-600">
                Welcome to your dashboard! Here you can manage your subscriptions and profile.
              </p>
            </div>
          </div>
        </div>
      </div>
    </SidebarProvider>
  );
};

export default Dashboard;
